import data from "../data";
import columns from "./tableColumns";
import { Spin, Table } from "antd";
import { usePaginationPrzelewy } from "../../../context/PaginationContextPrzelewy";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import SearchInput from "./search";
import ExpandTransfersRender from "./ExpandTransfersRender";
const WygenerowaneTable = () => {
    const { pagination, setPagination } = usePaginationPrzelewy();
    const navigate = useNavigate();
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);



    const onExpand = (expanded, record) => {
        setExpandedRowKeys((prevExpandedRowKeys) => {
            if (expanded) {
                return [...prevExpandedRowKeys, record.msr_generated_groups_id];
            } else {
                return prevExpandedRowKeys.filter((key) => key !== record.msr_generated_groups_id);
            }
        });
    };

    const handleTableChange = (paginationInfo) => {
        const { current, pageSize } = paginationInfo;
        setPagination((prev) => ({
            ...prev,
            current, // Update the current page
            pagesize: pageSize, // Update the page size
        }));
    };

    const rows = data();

    return (
        <>
            <div
                className="table-header"
                style={{
                    display: "flex",
                    gap: "10px",
                    marginBottom: "16px",
                    padding: "20px",
                    paddingBottom: "0",
                }}
            >
                <SearchInput></SearchInput>
            </div>
            <div className="table-body" style={{ padding: "20px", paddingTop: "0" }}>
                <Spin spinning={pagination.loading}>
                    <Table
                        columns={columns}
                        expandable={{
                            expandedRowRender: ExpandTransfersRender,
                            rowExpandable: (record) => record.transfers && record.transfers.length > 0,
                        }}
                        expandedRowKeys={expandedRowKeys}
                        onChange={handleTableChange} // Handle pagination changes
                        dataSource={rows.data}
                        loading={pagination.loading}
                        onExpand={onExpand}
                        expandIcon={false}
                        pagination={{
                            current: pagination.current,
                            pageSize: pagination.pagesize,
                            total: rows.total, // Replace with total number of records from your server
                            showSizeChanger: true, // Allows changing the page size
                            pageSizeOptions: ["1", "10", "20", "50", "100"]
                        }}
                    />
                </Spin>
            </div>
        </>
    );
};

export default WygenerowaneTable;
